module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAMFJREFUKJF9kssRgzAMRHedwuIUAldPqjCugiHHuBBoDJSDMfgb3Rhr9XaFiLL8rCkPGz5ECzEBAAbj0jbmArVWg5ISYooDVBAtti3idhEBUDDBz/oSUu7HnLC7yuIZg4HWFkYqIDofeLxUP8/xktGwFEWqatO4AerZdwGo0FTxNAbj4Bfb8aObVtNN9t6VcHe9hhCj5eg8AH4/a7oEGQ3vC6qXI6OhCuiC6hfbFZ0xmDf//5/hIN5bLkwGlPlSQawfF/JezLbayvgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sdingdantoudi.png
// module id = SGRR
// module chunks = 1